import React, { InputHTMLAttributes } from 'react';
import type { ReactNode } from 'react';
import classNames from 'classnames';
import { useSkipNavState } from './SkipNavUtils';

export interface MainContentProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'onBlur' | 'onFocus' | 'ref' | 'style' | 'tabIndex'> {
  children: ReactNode;
}

const MainContent = ({ children, className, ...rest }: MainContentProps): JSX.Element => {
  const { mainContentRef, mainContentOnFocus, mainContentOnBlur } = useSkipNavState();

  return (
    <main
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      className={classNames(className)}
      id="main-content"
      onBlur={mainContentOnBlur}
      onFocus={mainContentOnFocus}
      ref={mainContentRef}
      style={{ outline: 0 }}
    >
      {children}
    </main>
  );
};

export default MainContent;
